import { z } from '@/lib/zod'

export const ProfilePreferencesSchema = () =>
  z.object({
    avatarFile: z.union([z.string(), z.instanceof(File)]).optional(),
    displayName: z.string().optional(),
    language: z.string().optional(),
    email: z.string().email().optional(),
    allowedPosts: z.boolean().optional(),
    allowedApplications: z.array(
      z.object({
        label: z.string(),
        value: z.string(),
      }),
    ),
    registeredApplications: z.array(
      z.object({
        label: z.string(),
        value: z.string(),
      }),
    ),
  })

export type ProfilePreferencesForm = z.infer<
  ReturnType<typeof ProfilePreferencesSchema>
>
